import React, { useState } from 'react';
import PageTopButton from '@components/common/pageTopButton';
import Intro from '@components/events/eventProfile/intro';
import Order from '@components/events/eventProfile/order';
import Gift from '@components/events/eventProfile/gift';
import HowTo from '@components/events/eventProfile/howTo';
import Interview from '@components/events/eventProfile/interview';
import Tip from '@components/events/eventProfile/tip';
import Banner1 from '@components/events/eventProfile/banner1';
import Banner2 from '@components/events/eventProfile/banner2';
import Banner3 from '@components/events/eventProfile/banner3';
import Banner4 from '@components/events/eventProfile/banner4';
import LastBanner from '@components/events/eventProfile/lastBanner';
import Step from '@components/events/eventProfile/step';
import EventProfileFill, { ModalState } from './modal';
import useIO from '@utils/hooks/useIO';

import classnames from 'classnames/bind';

import styles from './commonStyle.module.scss';
const cx = classnames.bind(styles);

const EventProfile = () => {
  const [modalState, setModalState] = useState<ModalState>(null);
  const openModal = (type: ModalState) => setModalState(type);
  const [fadeInFirst, setFadeInFirst] = useState(false);

  // Intersection Observer
  const handleIntersectFirst = (entries: IntersectionObserverEntry[]) => {
    if (entries[0].isIntersecting) {
      setFadeInFirst(true);
    }
  };

  const setFirstSectionRef = useIO({ onIntersect: handleIntersectFirst, threshold: 0.2 });

  return (
    <div className={cx('wrap')}>
      {/* intro */}
      <Intro />

      {/* order */}
      <Order />

      {/* gift */}
      <Gift />

      {/* how to */}
      <HowTo />

      {/* Tip */}
      <div ref={setFirstSectionRef}>
        <Tip fadeIn={fadeInFirst} />
      </div>

      {/* Banner1 */}
      <Banner1 />

      {/* Step */}
      <Step openModal={openModal} />

      {/* Banner2 */}
      <Banner2 />

      {/* Banner3 */}
      <Banner3 />

      {/* Banner 4 */}
      <Banner4 />

      {/* interview */}
      <Interview />

      {/* last Banner */}
      <LastBanner />

      <EventProfileFill modalState={modalState} setModalState={setModalState} />

      <PageTopButton />
    </div>
  );
};

export default EventProfile;
